import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonInput, IonModal } from '@ionic/angular';
import { ColumnMode, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import type { OverlayEventDetail } from '@ionic/core';

@Component({
  selector: 'app-pos',
  templateUrl: './pos.component.html',
  styleUrls: ['./pos.component.scss'],
})
export class PosComponent implements OnInit {

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly JSON = JSON;

  sajatIntezmeny
  intezmeny = 2
  dolgozok = 0
  tanulok = 0
  felulet = 0
  import = 0
  besorolas = 0
  enaplo = 0
  dokumentumok = 0
  adatszolg = 0
  penzugy = 0
  modulok = 0
  munkatarssorok = [];
  datetime
  alkalmazk
  alkalmazv

  selected = [];
  telepules
  allampolgar
  orszag
  SelectionType = SelectionType;
  allomany
  csoport
  @ViewChild("uzenetmodal") modal: IonModal;
  segment = "1"

  portControl: FormControl;
  form: FormGroup;
  private rawHttp: HttpClient;

  constructor(private http: HttpClient, private data: DataService,
    private formBuilder: FormBuilder, private httpBackend: HttpBackend) {
    this.rawHttp = new HttpClient(this.httpBackend);
    this.form = this.formBuilder.group({
      brand: new FormControl("sumup", Validators.required),
      model: new FormControl("solo", Validators.required),
      merchant_id: new FormControl("", Validators.required),
      token: new FormControl("", Validators.required),
      name: new FormControl("", Validators.required),
      pairing_code: new FormControl("", Validators.required),
    });
  }

  async ngOnInit() {
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))

    this.getAllomany();
  }


  getRowClass = (row) => {
    return {
      'row-color-blue': row.priority == 1,
      'row-color-green': row.priority == 2,
      'row-color-orange': row.priority == 3,
      'row-color-red': row.priority == 4,
    };
  }

  initModal(id) {
    this.form.reset()
    let data = this.allomany.filter((it) => it.adid = id)[0]
    data.szul_hely = JSON.parse(data.szul_tel_o)
    data.szul_orszag = JSON.parse(data.szul_orszag_o)
    data.allampolgar_1 = JSON.parse(data.allampolgar_1_o)
    data.allampolgar_2 = JSON.parse(data.allampolgar_2_o)
    data.anyanyelv = JSON.parse(data.allampolgar_1_o)
    data.szul_datum = moment(data.szul_datum).format("YYYY-MM-DD")
    console.log(data)
    this.form.patchValue(data)
    console.log(this.form.value)
    this.modal.present();
  }
  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  getEletut() {
    this.http
      .get(
        'https://merfoldkovek.oh.gov.hu/api/User/Timeline',
        {

        }
      )
      .subscribe({
        next: (response) => {
          //this.allomany = response
          console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          /*
          {
              "allapot": "NincsMegFeliratkozva",
              "formatumVerzio": 1,
              "generalva": "0001-01-01T00:00:00",
              "adatok": null,
              "adatAllapot": "OsszeallitasAlatt",
              "leiratkozasOka": "Oktazonvaltozas",
              "leiratkozva": null,
              "letrehozva": null,
              "megtekintveUgyintezokent": false,
              "ugyintezoOktazon": null,
              "isSucceeded": true,
              "reasonOfFail": null,
              "muveletAzonosito": "67155014-3c68-47cc-802d-a68aee09ce1c",
              "errorCode": 0,
              "errorCodeString": "0000",
              "time": "2025-01-17T16:35:45.4874766+01:00"
          } */
        },
      });
  }

  getAllomany() {
    let headers = {
      intezmeny: this.sajatIntezmeny.intezmenyId
    }
    this.http
      .get(
        '/api/pos/terminals/' + this.sajatIntezmeny.intezmenyId,
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allomany = response
          console.log(this.allomany)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }



  cancel() {
    this.modal.dismiss(null, 'cancel');
  }
  async submit() {
    this.data.showLoading("Párosítás...")
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.form.value.token
      })
    };
    await this.rawHttp
      .post(
        environment.posapis.sumup + '/v0.1/merchants/' + this.form.value.merchant_id + '/readers',
        {
          //"description": "Teszt",
          "pairing_code": this.form.value.pairing_code,
          "name": this.form.value.name
        },
        httpOptions
      )
      .subscribe({
        next: async (response) => {

          await this.http
            .post(
              '/api/pos/create',
              {
                ...response,
                ...this.form.value,
                intezmeny: this.sajatIntezmeny.intezmenyId
              }
            )
            .subscribe({
              next: (response2) => {
                this.data.hideLoading()
                this.modal.dismiss()
                this.getAllomany()
              },
              error: (error) => {
                this.data.hideLoading()
                this.data.sendToast(error, "error")
                console.error('Error fetching data:', error);
              }
            })


        },
        error: (error) => {
          this.data.hideLoading()
          this.data.sendToast(error.message, "error")
          console.error('Error fetching data:', error);
        }
      })

  }

  selectChangedAnyanyelv(e) {

  }

    public alertButtons = [
    {
      text: 'Mégse',
      role: 'cancel',
      handler: () => {
        console.log('Alert canceled');
      },
    },
    {
      text: 'Törlés',
      role: 'confirm',
      handler: () => {
        console.log('Alert confirmed');
      },
    },
  ];

  async setResult(event: CustomEvent<OverlayEventDetail>,row) {
    if(event.detail.role=="confirm"){
      this.data.showLoading("Törlés...")

      const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + row.token
      })
    };
    await this.rawHttp
      .delete(
        environment.posapis.sumup + '/v0.1/merchants/' + row.merchant_id + '/readers/'+row.id,
        httpOptions
      )
      .subscribe({
        next: async (response) => {

          await this.http
            .post(
              '/api/pos/delete/'+row.id,
              {
              }
            )
            .subscribe({
              next: (response2) => {
                this.data.hideLoading()
                this.getAllomany()
              },
              error: (error) => {
                this.data.hideLoading()
                this.data.sendToast(error, "error")
                console.error('Error fetching data:', error);
              }
            })


        },
        error: (error) => {
          this.data.hideLoading()
          this.data.sendToast(error.message, "error")
          console.error('Error fetching data:', error);
        }
      })

    }
  }

}
